var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlasticCups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.241,
    height: 40.449,
    viewBox: "0 0 20.241 40.449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "soda-in-plastic-cup-with-straw-svgrepo-com",
    transform: "translate(-152.876)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    id: "Path_70",
    "data-name": "Path 70",
    d: "M173.117,21.12l-.917-5.528h-1.176a8.082,8.082,0,0,0-7.23-7.23V5.127l7.134-3.711L170.192,0,162.2,4.158v4.2a8.082,8.082,0,0,0-7.23,7.23h-1.176l-.916,5.528h1.805l2.449,19.329h11.732l2.45-19.329h1.805Zm-2.27-3.932.387,2.335h-7.439V17.188Zm-1.43-1.6h-5.622V9.969A6.482,6.482,0,0,1,169.417,15.591ZM162.2,9.969v5.622h-5.622A6.482,6.482,0,0,1,162.2,9.969Zm-7.052,7.219H162.2v2.335h-7.439ZM162.2,21.12v1.711h-5.691l-.217-1.711Zm5.257,17.733h-8.918L156.71,24.427H162.2v13.4h1.6v-13.4h5.489Zm2.03-16.021h-5.691V21.12H169.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasticCups);
export default __webpack_public_path__ + "static/media/plasticCups.ed9250088cf7e2aae7f2e594bace334b.svg";
export { ForwardRef as ReactComponent };